module.exports = "/images/avatar-s-26.jpg?fda3c31e1923d96ec010f9f5190946d2";